const env = {
  baseUrl: 'https://api.nallaienterprise.com/api/v1.0/',
};

export default env;
